import React from "react";
import {
  Row,
  Col,
  message,
  Button,
  Space,
  Input,
  Tooltip,
  Modal,
  Image,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import withRouter from "../withRouter";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import { CloseOutlined } from "@ant-design/icons";
import VehicleLiveLocationStore from "../store/VehicleLiveLocationStore";
import CompanyStore from "../store/CompanyStore";
import VehicleLiveLocationAdd from "./VehicleLiveLocationAdd";
import ShareModalWindow from "./ShareModalWindow";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
class VehicleLiveLocationList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.companyStore = new CompanyStore(this);
    this.onDelete = this.onDelete.bind(this);
    this.vehicleLiveLocationStore = new VehicleLiveLocationStore();

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      companyId: "",

      loadData: 0,
      company_value_label: "",
      listUpdated: 0,
      searchField: "",
      openLiveLocationAddForm: false,
      vehicleLiveLocationId: "",
      listDataUpdate: false,
      companyFieldHighlight: false,
      shareModalVisible: false,

      openDeleteModal: false,
      deleteData: {},
    };

    this.columns = [
      {
        // title: " Company Name ",
        title: context.translate("_COMPANY_NAME_"),
        dataIndex: "name",
        width: 25,
        ellipsis: {
          showTitle: true,
        },
        render: (value, record) => {
          return (
            <Tooltip placement="topLeft" title={value}>
              <Link
                style={{ color: "#2563EB", textDecoration: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  this.props.canUpdate("VehicleLiveLocationList") &&
                    this.onEdit(record);
                }}
              >
                {value}
              </Link>
            </Tooltip>
          );
        },
      },
      {
        // title: "Vehicle No ",
        title: context.translate("_VEHICLE_NO_"),
        dataIndex: "vehicleNo",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
        render: (vehicleNo) => (
          <Tooltip placement="topLeft" title={vehicleNo}>
            {vehicleNo}
          </Tooltip>
        ),
      },
      {
        // title: "Account Expiry Date",
        title: context.translate("_FLEET_COMPANY_COMPANYDETAIL_EXPIREDATE_"),
        dataIndex: "expiryDate",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
        render: (expiryDate) => (
          <Tooltip placement="topLeft" title={expiryDate}>
            {expiryDate}
          </Tooltip>
        ),
      },
      {
        // title: " Live Location URL ",
        title: context.translate("_LIVE_LOCATION_URL_"),
        dataIndex: "locationUrl",
        width: 25,
        ellipsis: {
          showTitle: true,
        },

        render: (value) => {
          const handleLinkClick = () => {
            window.open(value, "_blank");
          };
          return (
            <Tooltip placement="topLeft" title={value}>
              <span style={{ cursor: "pointer" }} onClick={handleLinkClick}>
                {value}
              </span>
            </Tooltip>
          );
        },
      },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "Action",
        key: "Action",
        // fixed: 'right',
        width: 10,
        align: "center",
        ellipsis: {
          showTitle: true,
        },
        render: (_, record) => {
          console.log(record);
          return (
            <>
              <Space>
                {/* <Link
                  onClick={(e) => {
                    e.preventDefault();
                    this.onEdit(record);
                  }}
                >
                  <Tooltip
                    // title="Edit"
                    title={context.translate("_FLEET_COMPANY_COMPANYLIST_EDIT_")}
                    placement="bottom"
                    color={config.tooltipColorEdit}
                  >
                    <EditFilled />
                  </Tooltip>
                </Link> */}
                {/* <DeleteConfirm
                  onConfirm={(e) => {
                    e.preventDefault();
                    this.onDelete(record);
                  }}
                >
                  <Link>
                    <Tooltip
                      // title="Delete"
                      title={context.translate(
                        "_FLEET_COMPANY_COMPANYLIST_DELETE_"
                      )}
                      placement="bottom"
                      color={config.tooltipColorDelete}
                    >
                      <DeleteFilled style={{ color: config.deleteColor }} />
                    </Tooltip>
                  </Link>
                </DeleteConfirm> */}
                <Tooltip
                  title={this.context.translate(
                    "_FLEET_COMPANY_COMPANYLIST_EDIT_"
                  )}
                >
                  {this.props.canUpdate("VehicleLiveLocationList") && (
                    <Image
                      style={{
                        height: "19px",
                        width: "15px",
                        borderRadius: "0px",
                        cursor: "pointer",
                      }}
                      src={editIcon}
                      onClick={async (e) => {
                        e.preventDefault();
                        await this.onEdit(record);
                      }}
                    ></Image>
                  )}
                </Tooltip>
                <Tooltip title={this.context.translate("_SHARE_LOCATION_")}>
                  <Image
                    src={require("../assets/images/detailtracking/share-icon.png")}
                    height={15}
                    width={15}
                    onClick={() => {
                      this.setState({ shareModalVisible: record.locationUrl });
                      // console.log(data);
                    }}
                  />
                </Tooltip>
                <Tooltip
                  title={this.context.translate(
                    "_FLEET_COMPANY_COMPANYLIST_DELETE_"
                  )}
                >
                  {this.props.canDelete("VehicleLiveLocationList") && (
                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer", width: "15px" }}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    ></Image>
                  )}
                </Tooltip>
              </Space>
            </>
          );
        },
      },
    ];
  }
  onEdit = async (record) => {
    await this.context.viewStateStore.setLiveLocationStates({
      companyId: record.companyId,
    });
    await this.setState({ vehicleLiveLocationId: record.id });
    await this.setState({ openLiveLocationAddForm: true });
    // this.props.navigate(
    //   "/vehiclelivelocationadd/" + record.id + "/" + record.vehicleId
    // );
  };

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const beforeEditCompanyId =
        this.context.viewStateStore.liveLocationObject.companyId;
      if (beforeEditCompanyId !== "") {
        await this.vehicleLiveLocationStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: beforeEditCompanyId,
        });
        const singleData = await this.companyStore.getCompanyDataById(
          this.context.viewStateStore.liveLocationObject.companyId
        );
        await this.setState({ listUpdated: 1 }); //need to reload data
        await this.setState({
          company_value_label: singleData,
          companyId: beforeEditCompanyId,
        });
      }
      this.setState({ listDataUpdate: false });
    }
  }
  async componentDidMount() {
    if (Number(this.props.getUserData().isadmin) !== -1) {
      this.context.viewStateStore.setUserAddStates({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ isadmin: this.props.getUserData().isadmin });
      await this.handleSearch();
    }
    // await this.vehicleLiveLocationStore.loadData({ offset: 0, limit: 50 });

    this.setState({ pageSize: 50 });

    await this.setState({ listUpdated: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({
      companyId: comp.value,
      currentPage: 1,
      pageSize: 50,
    });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    await this.setState({ company_value_label: singleData });

    await this.handleSearch();
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.vehicleLiveLocationStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
      companyId: this.state.companyId,
    });
    await this.setState({ loadData: 1 });
  }

  async onDelete(record) {
    const response = await this.vehicleLiveLocationStore.deleteRecord({
      id: record.id,
    });
    //  console.log(response.data.success)
    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
    this.setState({ loadData: 1 });
  }
  searchInput = async (e) => {
    const value = e.target.value;
    if (value.length > 3 || value.length === 0) {
      await this.vehicleLiveLocationStore.loadData({
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,

        searchField: value,
        companyId: this.state.companyId,
      });
      await this.setState({ loadData: 1 });
    }
  };

  refreshList = async () => {
    this.setState({ loading: true });
    if (this.state.companyId) {
      await this.vehicleLiveLocationStore.loadData({
        companyId: this.state.companyId,
        offset: 0,
        limit: 50,
        searchField: "",
      });
    }
    this.setState({ loading: false, searchField: "", currentPage: 1 });
  };

  onSearchClick = async () => {
    if (!this.state.companyId) {
      this.setState({ companyFieldHighlight: true });
    } else {
      this.setState({ companyFieldHighlight: false });
    }
    if (this.state.companyId) {
      this.setState({ companyFieldHighlight: false, loading: true });
      await this.vehicleLiveLocationStore.loadData({
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,
        searchField: this.state.searchField,
        companyId: this.state.companyId,
      });
      await this.setState({ loadData: 1 });
    }
  };

  responseMsg = async (resp) => {
    // console.log(resp.data.errors)
    if (resp.data.success == "S") {
      message.success(resp.data.message);
      //  this.props.navigate("/vehiclelivelocationlist");
      await this.setState({ openLiveLocationAddForm: false });
      await this.setState({ listDataUpdate: true });
    } else if (resp.data.success == "F4000") {
      resp.data.errors.map((value) => {
        message.error(value["vehicleNo"]);
        // message.error(resp.data.message);
      });
    }
  };

  closeModal = () => {
    this.setState({
      openLiveLocationAddForm: false,
      vehicleLiveLocationId: "",
    });
  };

  render() {
    const companyInputBox = this.state.companyFieldHighlight
      ? { border: "2px solid red", width: "150px", borderRadius: "8px" }
      : { width: "150px" };
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  // allowClear={true}
                  value={
                    this.state.company_value_label
                      ? this.state.company_value_label
                      : null
                  }
                  onChange={(value) => this.handleChange(value)}
                  style={companyInputBox}
                />
                <Input
                  style={{ width: 300, borderRadius: "25px" }}
                  value={this.state.searchField ? this.state.searchField : ""}
                  placeholder={this.context.translate("_SEARCH_BY_VEHICLE_NO_")}
                  onKeyUp={(e) => this.searchInput(e)}
                  onChange={async (e) => {
                    await this.setState({ searchField: e.target.value });
                  }}
                />
                {/* <Button
                  icon={<SearchOutlined />}
                  type="primary"
                  onClick={this.onSearchClick}
                /> */}
              </Space>
            </Col>

            <Col
              span={8}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Tooltip
                title={this.context.translate("_REFRESH_")}
                placement="bottom"
              >
                <Image
                  style={{
                    height: 18,
                    alignItems: "center",
                    cursor: "pointer",
                    marginInlineEnd: "20px",
                  }}
                  src={refreshIcon}
                  onClick={() => this.refreshList()}
                ></Image>
              </Tooltip>
              {this.props.canCreate("VehicleLiveLocationList") && (
                <Button
                  className="addButtonClass"
                  onClick={() => {
                    this.setState({
                      openLiveLocationAddForm: true,
                      vehicleLiveLocationId: "",
                    });
                  }}
                >
                  <Image
                    style={{ marginInlineEnd: "5px", width: 13 }}
                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                  ></Image>
                  {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                </Button>
              )}
            </Col>
          </Row>

          <ListTable
            currentPage={this.state.currentPage}
            total={this.vehicleLiveLocationStore?.total}
            pageSize={this.state.pageSize}
            columns={this.columns}
            dataSource={
              this.vehicleLiveLocationStore?.vehicleLiveLocationVehicles
            }
            loading={this.vehicleLiveLocationStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openLiveLocationAddForm && (
          // <Modal
          //   bodyStyle={{ height: "645px" }}
          //   className="formShowModal" //  {/* css class */}
          //   // title="Live Location"
          //   title={this.context.translate("_LIVE_LOCATION_")}
          //   centered
          //   visible={this.state.openLiveLocationAddForm}
          //   footer={null}
          //   onCancel={() => {
          //     this.setState({
          //       openLiveLocationAddForm: false,
          //       vehicleLiveLocationId: "",
          //     });
          //   }}
          //   width={665}
          // >
          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openLiveLocationAddForm}
            placement={
              this.context.locale.language === "arabic" ? "left" : "right"
            }
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_LIVE_LOCATION_")}
                <p className="formDescription">
                  {this.context.translate("_VEHICLE_DISTANCE_ADD_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openLiveLocationAddForm: false })}
            onCancel={() =>
              this.setState({
                openLiveLocationAddForm: false,
                vehicleLiveLocationId: "",
              })
            }
          >
            <div style={{ height: "100%" }}>
              <VehicleLiveLocationAdd
                vehicleLiveLocationId={this.state.vehicleLiveLocationId}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Drawer>
        )}

        {this.state.shareModalVisible && (
          <ShareModalWindow
            shareModalCloseFunc={(resp) =>
              this.setState({ shareModalVisible: resp })
            }
            shareLiveLocation={this.state.shareModalVisible}
          />
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
VehicleLiveLocationList.contextType = StoreContext;
export default observer(withRouter(VehicleLiveLocationList));
